import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { DatePipe } from '@angular/common';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ReportQueryResultsModel } from './report-view-model';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({
  providedIn: 'root'
})
export class ExcelServicesService {

  constructor(private datePipe: DatePipe, private http: HttpClient) { }

  public exportAsExcelFile(json: any[], excelFileName: string, reportData : any): void {
    var worksheet = XLSX.utils.json_to_sheet([]);
     //then add ur txt
    XLSX.utils.sheet_add_json(worksheet,
      [
        {note: "Report Generated On:" + this.datePipe.transform(reportData.CreatedOn, 'yyyy-MM-dd hh:mm aa')},
        //{note: "Corporation:" + reportData.Client},
        {note: "Date from:" + this.datePipe.transform(reportData.DateFrom, 'yyyy-MM-dd')},
        {note: "Date to:" + this.datePipe.transform( reportData.DateTo, 'yyyy-MM-dd')}
      ],
      {
        header: ["note"],
        skipHeader:true,
        origin: "A1"
      }
    );

    //XLSX.utils.sheet_add_json(worksheet,json.length === undefined ? [json] : json,
    // {       
    //   origin : "A5",
    // });
     
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  public exportPortalFile(reportData: ReportQueryResultsModel, excelFileName: string, header: any): void {


    var url = "assets/data/Portal_File_Report.xlsx";
    var oReq = new XMLHttpRequest();
    oReq.open("GET", url, true);
    oReq.responseType = "arraybuffer";
    let tra = this.datePipe;

    oReq.onload = function (e) {
      var arraybuffer = oReq.response;

      /* convert data to binary string */
      var data = new Uint8Array(arraybuffer);
      var arr = new Array();
      for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
      var bstr = arr.join("");

      /* Call XLSX */
      var workbook = XLSX.read(bstr, { type: "binary" });

      var first_sheet_name = workbook.SheetNames[0];
      var worksheet = workbook.Sheets[first_sheet_name];
      XLSX.utils.sheet_add_aoa(worksheet, [[tra.transform(header.CreatedOn, 'yyyy-MM-dd hh:mm aa')]], { origin: 'B2' });
      XLSX.utils.sheet_add_aoa(worksheet, [[tra.transform(header.DateFrom, 'yyyy-MM-dd')]], { origin: 'B3' });
      XLSX.utils.sheet_add_aoa(worksheet, [[tra.transform(header.DateTo, 'yyyy-MM-dd')]], { origin: 'B4' });
      XLSX.utils.sheet_add_aoa(worksheet, [[reportData.totalRecords]], { origin: 'B9' });
      XLSX.utils.sheet_add_aoa(worksheet, [[reportData.totalLenders]], { origin: 'C9' });
      XLSX.utils.sheet_add_aoa(worksheet, [[reportData.sufficientCoverageCount]], { origin: 'D9' });
      XLSX.utils.sheet_add_aoa(worksheet, [[reportData.inSufficientCoverageCount]], { origin: 'E9' });
      XLSX.utils.sheet_add_aoa(worksheet, [[reportData.firstNameMismatchCount]], { origin: 'F9' });
      XLSX.utils.sheet_add_aoa(worksheet, [[reportData.lastNameMismatchCount]], { origin: 'G9' });
      XLSX.utils.sheet_add_aoa(worksheet, [[reportData.addressMismatchCount]], { origin: 'H9' });
      XLSX.utils.sheet_add_aoa(worksheet, [[reportData.noMatchCount]], { origin: 'I9' });
      var sheet_name = workbook.SheetNames[1];
      worksheet = workbook.Sheets[sheet_name];

      var json1 = JSON.parse(reportData.data)['ArrayOfEnsurexReportDataModel']['EnsurexReportDataModel'];
      XLSX.utils.sheet_add_json(worksheet, json1.length === undefined ? [json1] : json1,
          {
            origin: "A2",
          });


      const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

      const exceldata: Blob = new Blob([excelBuffer], { type: EXCEL_TYPE });
      FileSaver.saveAs(exceldata, excelFileName + ' Report' + EXCEL_EXTENSION);


      
      
      //var json1 = JSON.parse(reportData.data)['ArrayOfEnsurexReportDataModel']['EnsurexReportDataModel'];
      

    }
    oReq.send();


  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(data, fileName + ' Report' + EXCEL_EXTENSION);
  }

 

}
